'use client';

import { useEffect, useRef } from 'react';
import { useSession } from 'next-auth/react';

/**
 * 10.8 / 8.0.6: При преход към authenticated извиква merge на гостова чернова с userId.
 * Cookie checkout_draft_id се изпраща автоматично; сървърът обновява CheckoutDraft.userId.
 */
export default function MergeDraftOnLogin() {
  const { status } = useSession();
  const hasMergedRef = useRef(false);

  useEffect(() => {
    if (status === 'unauthenticated') {
      hasMergedRef.current = false;
      return;
    }
    if (status !== 'authenticated') {
      return;
    }
    if (hasMergedRef.current) {
      return;
    }
    hasMergedRef.current = true;
    fetch('/api/checkout-draft/merge', {
      method: 'POST',
      credentials: 'include',
    }).catch(() => {
      hasMergedRef.current = false;
    });
  }, [status]);

  return null;
}
